import { BrowserRouter } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import Footer from "./components/sections/Footer";
import SocialIcons from "./components/SocailIcons";
import Navbar from "./components/Navbar";
import Application from "./Application";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/global.css";
import "./assets/css/terminal.css";
import Chat from "./pages/Chat";
import { useEffect, useState } from "react";
import { connectSocket, disconnectSocket } from "./utils/Socket";

// darkTheme
function App() {
  const [userId, setUserId] = useState();

  useEffect(() => {
    const loadUserId = async () => {
      const id = "user-" + Math.random().toString(36).slice(2, 9);
      setUserId(id);
    };

    loadUserId();
  }, []);

  useEffect(() => {
    if (!userId) return;
    // Connect only after userId is ready
    connectSocket(userId);

    return () => {
      disconnectSocket(); // Clean up on app exit
    };
  }, [userId]);

  return (
    <BrowserRouter>
      <Navbar />
      <div className="main-container">
        <AnimatePresence>
          <Application />
        </AnimatePresence>
        <Footer />
        <SocialIcons color="light" />

        {userId && <Chat userId={userId} />}
      </div>
    </BrowserRouter>
  );
}

export default App;
